// src/components/common/NotificationBadge.tsx
import { Bell } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
    Badge, Button, DropdownMenuTrigger, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from "@/components/ui";

type NotificationBadgeProps = {
    count: number;
};

export default function NotificationBadge({ count }: NotificationBadgeProps) {
    const { t } = useTranslation();

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <DropdownMenuTrigger asChild>
                        <Button variant="ghost" size="icon" className="rounded-full relative">
                            <Bell className="h-5 w-5" strokeWidth={1.5} />
                            <Badge className="absolute -top-1 -right-1 h-4 w-4 p-0 flex items-center justify-center font-normal">
                                {count}
                            </Badge>
                        </Button>
                    </DropdownMenuTrigger>
                </TooltipTrigger>
                <TooltipContent>
                    <p>{t("header.notifications")}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
} 